module.exports = __webpack_public_path__ + "account/img/228.6af64a83.png";